/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import MenuItem from "./MenuItem";
import { useHistory } from "react-router-dom";
import options from "./options";
import Icon from "components/common_components/Icon";

function Menu({ children }) {
    const [navOpen, setNavigation] = useState(true);
    const history = useHistory();
    const [selectedOption, setSelectedOption] = useState();

    const toggleNavigation = () => {
        setNavigation(!navOpen);
    };

    useEffect(() => {
        const flattedOptions = options.reduce((newOptions, { options }) => {
            return [...newOptions, ...options];
        }, []);
        const newSelectedOption = flattedOptions.find((o) => {
            if (o.isHome) {
                return o.path && history.location.pathname === "/";
            }
            return o.path && history.location.pathname.startsWith(o.path);
        });
        if (newSelectedOption) {
            setSelectedOption(newSelectedOption);
        }
    }, [history.location.pathname]);

    return (
        <div className="wrapper">
            <nav className={`nav ${navOpen ? "" : "nav--small"}`}>
                <div className="nav__header nav-inner">
                    <p className="text--white">Storybook</p>

                    <div className="nav-toggle" onClick={toggleNavigation}>
                        <Icon name="arrow" color="primary" size="sm" />
                        <span className="font-small text--grey hide-nav-small">Collapse</span>
                    </div>
                </div>

                <div className="nav__body">
                    {options
                        .filter((section) => section.options.length > 0)
                        .map(({ index, options }) => {
                            return (
                                <div className="nav-list" key={index}>
                                    {options
                                        .filter((x) => Boolean(x))
                                        .map((option) => {
                                            const { key, label, path, icon } = option;
                                            const selected = selectedOption ? selectedOption.key === key : false;
                                            return (
                                                <MenuItem
                                                    key={key}
                                                    selected={selected}
                                                    label={label}
                                                    path={path}
                                                    icon={icon}
                                                />
                                            );
                                        })}
                                </div>
                            );
                        })}
                </div>

                <div className="nav__footer nav-inner"></div>
            </nav>
            <main className={`main ${navOpen ? "" : "main--small"}`}>
                <div className={`main-actions ${navOpen ? "" : "main-actions--small"}`}>{/* <FloatingNotifications /> */}</div>
                {children}
            </main>
        </div>
    );
}

export default Menu;
